import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

const apiUrl = environment.baseApiUrl;

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  options() {
    return {
      headers: new HttpHeaders({
        // 'Authorization': 'Token ' + localStorage.getItem('securityToken'),
        'content-Type': 'application/json'
      })
    };
  }

  constructor(private httpClient: HttpClient) { }

  registerUser(user) {
    return this.httpClient.post(`${apiUrl}/user/register`, user, this.options());
  }
  checkToken(token) {
    return this.httpClient.get(`${apiUrl}/user/activate/` + token, this.options());
  }
  resetPassword(request) {
    return this.httpClient.put(`${apiUrl}/user/reset-password`, request, this.options());
  }

  askResetPassword(request) {
    return this.httpClient.put(`${apiUrl}/user/cant-login`, request, this.options());
  }
}
